var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7683 2C10.543 2 9.45981 2.79632 9.09432 3.96587L7.5839 8.79923C7.47327 9.15325 7.41699 9.522 7.41699 9.89291V21.25C7.41699 21.7563 7.8274 22.1667 8.33366 22.1667L16.909 22.1673C18.7507 22.1673 20.3693 20.9464 20.8753 19.1755L22.5187 13.4237C23.1043 11.3742 21.5653 9.33398 19.4338 9.33398L15.2676 9.33346C14.7389 9.33339 14.3199 8.88729 14.3528 8.35961L14.5643 4.97623C14.6651 3.36343 13.3842 2 11.7683 2Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9.33398,
    width: 6.41667,
    height: 12.8333,
    rx: 0.916667,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.6dd98629b446cc770c3c01c09f56ffbc.svg";
export { ForwardRef as ReactComponent };